import { useEditor, type UseEditorOptions } from '@tiptap/react'
import { ExtensionKit } from './extensions'

export function useBlockEditor(props: UseEditorOptions) {
	const editor = useEditor({
		immediatelyRender: false,
		shouldRerenderOnTransaction: false,
		autofocus: true,
		content: props.content,
		editorProps: {
			attributes: {
				autocomplete: 'off',
				autocorrect: 'off',
				autocapitalize: 'off',
				class: 'min-h-full',
			},
		},
		extensions: [...ExtensionKit],
		...props,
	})

	return { editor }
}
